export const reportSampleAssessmentSummary = {
    candidatesSummary: {
        total: 3,
        completed: 2,
        completedRate: 66.6
    },
    averageSummary: {
        score: 73.5,
        takeTime: 7126,
        totalTakeTime: 10800,
        skillAcquisitionRate: 72.0
    },
    resultSummary: "No data available for analysis.",
    trackDescriptions: [
        {
            trackLevelName: "Beginner",
            trackName: "Prompt Engineering for Developers",
            trackId: 572,
            trackLevelDescription: "The Beginner Level focuses on mastering the foundational techniques of prompt engineering. It covers clear prompt construction, constraint-based output control, and structured data input/output design to ensure predictable and high-quality responses."
        },
        {
            trackLevelName: "Intermediate",
            trackName: "JavaScript",
            trackId: 200001,
            trackLevelDescription: "This level covers intermediate knowledge and practical skills in JavaScript. It evaluates the ability to understand object-oriented programming principles and to write reusable, maintainable code using classes and inheritance. It also includes understanding of core JavaScript mechanisms such as closures and binding, and the capability to apply them in real-world application design."
        }
    ]
}

export const reportSampleTrackSummaries = [
    {
        trackSummary: {
            trackName: "Prompt Engineering for Developers",
            trackLevelName: "Beginner",
            trackId: 572,
            trackLevelId: 874,
            testTemplateId: 0
        },
        trackResultSummary: "",
        trackDetails: {
            scores: {
                lowest: 60.0,
                medium: 71.5,
                highest: 83.0,
                average: 71.5,
                position: "LOWEST"
            },
            standardDeviation: 11.5,
            averageTimeTaken: 3015,
            scoreData: {
                top10Percentile: 80,
                top25Percentile: 77,
                top50Percentile: 71,
                median: 71.5,
                bottomPercentile: 60,
                distribution: [
                    { range: { first: 0, second: 9 }, percentage: 0, count: 0 },
                    { range: { first: 10, second: 19 }, percentage: 0, count: 0 },
                    { range: { first: 20, second: 29 }, percentage: 0, count: 0 },
                    { range: { first: 30, second: 39 }, percentage: 0, count: 0 },
                    { range: { first: 40, second: 49 }, percentage: 0, count: 0 },
                    { range: { first: 50, second: 59 }, percentage: 0, count: 0 },
                    { range: { first: 60, second: 69 }, percentage: 50, count: 1 },
                    { range: { first: 70, second: 79 }, percentage: 0, count: 0 },
                    { range: { first: 80, second: 89 }, percentage: 50, count: 1 },
                    { range: { first: 90, second: 100 }, percentage: 0, count: 0 }
                ],
                candidateLegendValue: -1,
                positionOnChart: -1
            },
            timeData: {
                distribution: [
                    { range: { first: 48, second: 48 }, percentage: 50, count: 1 },
                    { range: { first: 49, second: 49 }, percentage: 0, count: 0 },
                    { range: { first: 50, second: 50 }, percentage: 0, count: 0 },
                    { range: { first: 51, second: 51 }, percentage: 0, count: 0 },
                    { range: { first: 52, second: 52 }, percentage: 50, count: 1 },
                    { range: { first: 53, second: 53 }, percentage: 0, count: 0 },
                    { range: { first: 54, second: 54 }, percentage: 0, count: 0 },
                    { range: { first: 55, second: 55 }, percentage: 0, count: 0 },
                    { range: { first: 56, second: 56 }, percentage: 0, count: 0 },
                    { range: { first: 57, second: 58 }, percentage: 0, count: 0 }
                ],
                candidateLegendValue: -1,
                positionOnChart: -1
            }
        },
        skillAcquisitionDetails: {
            description: "",
            skillAcquisitionRate: {
                lowest: 65.0,
                medium: 75.2,
                highest: 85.5,
                average: 75.2,
                position: "HIGHEST"
            },
            standardDeviation: 10.2,
            positionOnChart: -1,
            distribution: [
                { range: { first: 0, second: 9 }, percentage: 0, count: 0 },
                { range: { first: 10, second: 19 }, percentage: 0, count: 0 },
                { range: { first: 20, second: 29 }, percentage: 0, count: 0 },
                { range: { first: 30, second: 39 }, percentage: 0, count: 0 },
                { range: { first: 40, second: 49 }, percentage: 0, count: 0 },
                { range: { first: 50, second: 59 }, percentage: 0, count: 0 },
                { range: { first: 60, second: 69 }, percentage: 50, count: 1 },
                { range: { first: 70, second: 79 }, percentage: 0, count: 0 },
                { range: { first: 80, second: 89 }, percentage: 50, count: 1 },
                { range: { first: 90, second: 100 }, percentage: 0, count: 0 }
            ]
        }
    },
    {
        trackSummary: {
            trackName: "JavaScript",
            trackLevelName: "Intermediate",
            trackId: 200001,
            trackLevelId: 82,
            testTemplateId: 1
        },
        trackResultSummary: "",
        trackDetails: {
            scores: {
                lowest: 57.0,
                medium: 75.5,
                highest: 94.0,
                average: 75.5,
                position: "HIGHEST"
            },
            standardDeviation: 18.5,
            averageTimeTaken: 4111,
            scoreData: {
                top10Percentile: 90,
                top25Percentile: 84,
                top50Percentile: 75,
                median: 75.5,
                bottomPercentile: 57,
                distribution: [
                    { range: { first: 0, second: 9 }, percentage: 0, count: 0 },
                    { range: { first: 10, second: 19 }, percentage: 0, count: 0 },
                    { range: { first: 20, second: 29 }, percentage: 0, count: 0 },
                    { range: { first: 30, second: 39 }, percentage: 0, count: 0 },
                    { range: { first: 40, second: 49 }, percentage: 0, count: 0 },
                    { range: { first: 50, second: 59 }, percentage: 50, count: 1 },
                    { range: { first: 60, second: 69 }, percentage: 0, count: 0 },
                    { range: { first: 70, second: 79 }, percentage: 0, count: 0 },
                    { range: { first: 80, second: 89 }, percentage: 0, count: 0 },
                    { range: { first: 90, second: 100 }, percentage: 50, count: 1 }
                ],
                candidateLegendValue: -1,
                positionOnChart: -1
            },
            timeData: {
                distribution: [
                    { range: { first: 55, second: 57 }, percentage: 50, count: 1 },
                    { range: { first: 58, second: 60 }, percentage: 0, count: 0 },
                    { range: { first: 61, second: 63 }, percentage: 0, count: 0 },
                    { range: { first: 64, second: 66 }, percentage: 0, count: 0 },
                    { range: { first: 67, second: 69 }, percentage: 0, count: 0 },
                    { range: { first: 70, second: 72 }, percentage: 0, count: 0 },
                    { range: { first: 73, second: 75 }, percentage: 0, count: 0 },
                    { range: { first: 76, second: 78 }, percentage: 0, count: 0 },
                    { range: { first: 79, second: 81 }, percentage: 50, count: 1 },
                    { range: { first: 82, second: 85 }, percentage: 0, count: 0 }
                ],
                candidateLegendValue: -1,
                positionOnChart: -1
            }
        },
        skillAcquisitionDetails: {
            description: "",
            skillAcquisitionRate: {
                lowest: 51.1,
                medium: 70.1,
                highest: 89.1,
                average: 70.1,
                position: "LOWEST"
            },
            standardDeviation: 18.9,
            positionOnChart: -1,
            distribution: [
                { range: { first: 0, second: 9 }, percentage: 0, count: 0 },
                { range: { first: 10, second: 19 }, percentage: 0, count: 0 },
                { range: { first: 20, second: 29 }, percentage: 0, count: 0 },
                { range: { first: 30, second: 39 }, percentage: 0, count: 0 },
                { range: { first: 40, second: 49 }, percentage: 0, count: 0 },
                { range: { first: 50, second: 59 }, percentage: 50, count: 1 },
                { range: { first: 60, second: 69 }, percentage: 0, count: 0 },
                { range: { first: 70, second: 79 }, percentage: 0, count: 0 },
                { range: { first: 80, second: 89 }, percentage: 50, count: 1 },
                { range: { first: 90, second: 100 }, percentage: 0, count: 0 }
            ]
        }
    }
];

export const reportSampleSkillSummaries = [
    {
        trackSummary: {
            trackName: "Prompt Engineering for Developers",
            trackLevelName: "Beginner",
            trackId: 572,
            trackLevelId: 874,
            testTemplateId: 0
        },
        skills: [
            {
                id: 703,
                name: "Prompt Engineering Fundamentals",
                description: "Able to craft clear prompts and control the model's basic behavior.",
                distribution: {
                    acquired: { percentage: 100.0, count: 2 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 704,
                name: "Constraint-based Output Control",
                description: "Able to include explicit constraints in prompts to obtain the desired outputs.",
                distribution: {
                    acquired: { percentage: 100.0, count: 2 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 705,
                name: "Structured Data Input/Output JSON",
                description: "Able to control input/output in predefined data formats to facilitate downstream processing",
                distribution: {
                    acquired: { percentage: 100.0, count: 2 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 706,
                name: "Structured Data Input/Output XML",
                description: "Able to control input/output in predefined data formats to facilitate downstream processing",
                distribution: {
                    acquired: { percentage: 0.0, count: 0 },
                    needsImprovement: { percentage: 50.0, count: 1 },
                    notAcquired: { percentage: 50.0, count: 1 },
                    totalCount: 2
                }
            }
        ]
    },
    {
        trackSummary: {
            trackName: "JavaScript",
            trackLevelName: "Intermediate",
            trackId: 200001,
            trackLevelId: 82,
            testTemplateId: 1
        },
        skills: [
            {
                id: 467,
                name: "Function Design and Implementation",
                description: "This skill verifies the ability to define and call functions, and to appropriately separate and implement program logic. Candidates should be able to use parameters and return values correctly, while enhancing reusability and readability of functions.",
                distribution: {
                    acquired: { percentage: 50.0, count: 1 },
                    needsImprovement: { percentage: 50.0, count: 1 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 468,
                name: "Object-Oriented Programming",
                description: "This skill verifies the ability to structure programs and design reusable modules using classes and objects. Candidates should understand concepts such as inheritance, encapsulation, and polymorphism, and be able to apply them in code.",
                distribution: {
                    acquired: { percentage: 100.0, count: 2 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 469,
                name: "Data Structure Utilization",
                description: "This skill verifies the ability to select and utilize various data structures—such as arrays, objects, Maps, and Sets—according to their purpose. Candidates should be able to efficiently perform operations such as insertion, deletion, search, and sorting using appropriate data structures.",
                distribution: {
                    acquired: { percentage: 50.0, count: 1 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 50.0, count: 1 },
                    totalCount: 2
                }
            },
            {
                id: 470,
                name: "Error & Exception Handling",
                description: "This skill is designed to verify the ability to handle errors and exceptions in a JavaScript environment to ensure program stability. Candidates should be able to manage runtime errors using constructs such as try–catch and error objects, handle exceptions in asynchronous operations, and proactively prevent predictable error scenarios.",
                distribution: {
                    acquired: { percentage: 0.0, count: 0 },
                    needsImprovement: { percentage: 100.0, count: 2 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 471,
                name: "State Management",
                description: "This skill verifies the ability to implement conditional logic and control outputs based on application state. Candidates should understand how to evaluate conditions, apply branching structures, and produce the required outputs consistently according to specifications.",
                distribution: {
                    acquired: { percentage: 100.0, count: 2 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 472,
                name: "Asynchronous Programming",
                description: "This skill verifies the ability to handle asynchronous tasks efficiently and maintain application responsiveness. Candidates should be able to control asynchronous flows using Promises, async/await, and callback functions.",
                distribution: {
                    acquired: { percentage: 100.0, count: 2 },
                    needsImprovement: { percentage: 0.0, count: 0 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            },
            {
                id: 473,
                name: "Output Control and Formatting",
                description: "This skill is designed to verify the ability to present program results in JavaScript in a clear and readable format according to given requirements. Candidates should be able to apply appropriate string handling and output methods to produce well-structured and understandable results.",
                distribution: {
                    acquired: { percentage: 0.0, count: 0 },
                    needsImprovement: { percentage: 100.0, count: 2 },
                    notAcquired: { percentage: 0.0, count: 0 },
                    totalCount: 2
                }
            }
        ]
    }
];

export const reportSampleAssessmentCandidateSummary = {
    assessmentInformation: {
        assessmentName: "Sample Assessment",
        lastRecord: "2026-01-31 03:22:57.704502"
    },
    assessmentResultSummary: "In the JavaScript track the learner shows strong ability in class design, function decomposition, state handling and async control, producing code that closely follows the given specifications. In the Prompt Engineering track they design clear roles and output schemas, especially for JSON based workflows, and translate high level goals into precise, directive instructions. However, some JavaScript outputs do not match exact message formats, and error related messages are not fully aligned with the required conditions, while the XML prompt leaves attributes, highlight elements and examples under specified, limiting downstream control. Overall the profile reflects a contract oriented developer who can structure both code and prompts effectively, and with more focus on exact formatting, systematic error handling and explicit uncertainty rules, they appear ready to handle more complex, production like systems that integrate application logic with AI driven components.",
    userAssessmentInfo: {
        scoreRank: 1,
        totalScoreRank: 2,
        score: 88.5,
        comparedToOverallAverage: 15.0,
        totalTimeTaken: 10800,
        timeTaken: 6232
    },
    userScoreDistribution: {
        candidateLegendValue: 88,
        positionOnChart: 88,
        distribution: [
            {
                range: { first: 0, second: 9 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 10, second: 19 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 20, second: 29 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 30, second: 39 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 40, second: 49 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 50, second: 59 },
                percentage: 50,
                count: 1
            },
            {
                range: { first: 60, second: 69 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 70, second: 79 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 80, second: 89 },
                percentage: 50,
                count: 1
            },
            {
                range: { first: 90, second: 100 },
                percentage: 0,
                count: 0
            }
        ]
    },
    userTimeTakenDistribution: {
        candidateLegendValue: 103,
        positionOnChart: 103,
        distribution: [
            {
                range: { first: 103, second: 105 },
                percentage: 50,
                count: 1
            },
            {
                range: { first: 106, second: 108 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 109, second: 111 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 112, second: 114 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 115, second: 117 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 118, second: 120 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 121, second: 123 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 124, second: 126 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 127, second: 129 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 130, second: 133 },
                percentage: 50,
                count: 1
            }
        ]
    },
    userSkillAcquisitionInfo: {
        skillAcquisitionRate: 87.8,
        totalSkillAcquisitionRateRank: 2,
        skillAcquisitionRateRank: 1,
        comparedToOverallAverage: 15.8
    },
    assessmentSkillAcquisitionRateDistribution: {
        candidateLegendValue: 87,
        positionOnChart: 87,
        distribution: [
            {
                range: { first: 0, second: 9 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 10, second: 19 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 20, second: 29 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 30, second: 39 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 40, second: 49 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 50, second: 59 },
                percentage: 50,
                count: 1
            },
            {
                range: { first: 60, second: 69 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 70, second: 79 },
                percentage: 0,
                count: 0
            },
            {
                range: { first: 80, second: 89 },
                percentage: 50,
                count: 1
            },
            {
                range: { first: 90, second: 100 },
                percentage: 0,
                count: 0
            }
        ]
    },
    trackDescriptions: [
        {
            trackLevelName: "Beginner",
            trackName: "Prompt Engineering for Developers",
            trackId: 572,
            trackLevelDescription: "The Beginner Level focuses on mastering the foundational techniques of prompt engineering. It covers clear prompt construction, constraint-based output control, and structured data input/output design to ensure predictable and high-quality responses."
        },
        {
            trackLevelName: "Intermediate",
            trackName: "JavaScript",
            trackId: 200001,
            trackLevelDescription: "This level covers intermediate knowledge and practical skills in JavaScript. It evaluates the ability to understand object-oriented programming principles and to write reusable, maintainable code using classes and inheritance. It also includes understanding of core JavaScript mechanisms such as closures and binding, and the capability to apply them in real-world application design."
        }
    ]
};

export const reportSampleTrackCandidateSummaries = [
    {
        trackSummary: {
            trackName: "Prompt Engineering for Developers",
            trackLevelName: "Beginner",
            trackId: 572,
            trackLevelId: 874,
            testTemplateId: 0
        },
        trackResultSummary: "This candidate demonstrates strong AI utilization skills, particularly in giving clear instructions and designing structured outputs. They excel at defining AI roles (like 'act as a senior reviewer'), specifying what information to include, and organizing results in a systematic way. Their strength lies in JSON-based structured data handling, which is excellent for automation and system integration. However, they need improvement in handling uncertain situations (what to do when information is incomplete) and in XML-based output design (less detailed than their JSON work). Overall, this is an advanced-level AI user with a methodical, contract-oriented approach who, with practice in edge case handling and richer output templates, could design enterprise-grade AI workflows.",
        userTrackDetailInfo: {
            score: 83.0,
            scoreRank: 1,
            totalScoreRank: 2,
            statPosition: "LOWEST",
            comparedToOverallAverageScoreInAssessment: 11.5,
            timeTaken: 2887,
            scoreData: {
                top10Percentile: 80,
                top25Percentile: 77,
                top50Percentile: 71,
                median: 71.5,
                bottomPercentile: 60,
                distribution: [
                    {
                        range: { first: 0, second: 9 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 10, second: 19 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 20, second: 29 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 30, second: 39 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 40, second: 49 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 50, second: 59 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 60, second: 69 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 70, second: 79 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 80, second: 89 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 90, second: 100 },
                        percentage: 0,
                        count: 0
                    }
                ],
                candidateLegendValue: 83,
                positionOnChart: 83
            },
            timeData: {
                distribution: [
                    {
                        range: { first: 48, second: 48 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 49, second: 49 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 50, second: 50 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 51, second: 51 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 52, second: 52 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 53, second: 53 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 54, second: 54 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 55, second: 55 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 56, second: 56 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 57, second: 58 },
                        percentage: 0,
                        count: 0
                    }
                ],
                candidateLegendValue: 48,
                positionOnChart: 48
            }
        },
        userSkillAcquisitionDetailInfo: {
            skillAcquisitionRate: 85.5,
            skillAcquisitionRateRank: 1,
            totalSkillAcquisitionRateRank: 2,
            comparedToOverallAverageRateInAssessment: 10.3,
            statPosition: "LOWEST",
            candidateLegendValue: 85,
            positionOnChart: 85,
            distribution: [
                {
                    range: { first: 0, second: 9 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 10, second: 19 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 20, second: 29 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 30, second: 39 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 40, second: 49 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 50, second: 59 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 60, second: 69 },
                    percentage: 50,
                    count: 1
                },
                {
                    range: { first: 70, second: 79 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 80, second: 89 },
                    percentage: 50,
                    count: 1
                },
                {
                    range: { first: 90, second: 100 },
                    percentage: 0,
                    count: 0
                }
            ]
        }
    },
    {
        trackSummary: {
            trackName: "JavaScript",
            trackLevelName: "Intermediate",
            trackId: 200001,
            trackLevelId: 82,
            testTemplateId: 1
        },
        trackResultSummary: "In the JavaScript track the learner shows strong skills in class design, core method implementation, state based logic and async flows, closely following the required behaviors. However, message formatting and condition specific outputs are not always aligned with the exact phrases, and data structure usage does not fully reflect the requested Map based registry, which affects strict specification compliance. Overall the learner demonstrates an intermediate JavaScript level with solid control of state and asynchronous behavior, and by tightening exact output strings, registry abstraction and condition based messages they can move toward more production ready, specification driven code quality.",
        userTrackDetailInfo: {
            score: 94.0,
            scoreRank: 1,
            totalScoreRank: 2,
            statPosition: "HIGHEST",
            comparedToOverallAverageScoreInAssessment: 18.5,
            timeTaken: 3345,
            scoreData: {
                top10Percentile: 90,
                top25Percentile: 84,
                top50Percentile: 75,
                median: 75.5,
                bottomPercentile: 57,
                distribution: [
                    {
                        range: { first: 0, second: 9 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 10, second: 19 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 20, second: 29 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 30, second: 39 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 40, second: 49 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 50, second: 59 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 60, second: 69 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 70, second: 79 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 80, second: 89 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 90, second: 100 },
                        percentage: 50,
                        count: 1
                    }
                ],
                candidateLegendValue: 94,
                positionOnChart: 94
            },
            timeData: {
                distribution: [
                    {
                        range: { first: 55, second: 57 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 58, second: 60 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 61, second: 63 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 64, second: 66 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 67, second: 69 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 70, second: 72 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 73, second: 75 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 76, second: 78 },
                        percentage: 0,
                        count: 0
                    },
                    {
                        range: { first: 79, second: 81 },
                        percentage: 50,
                        count: 1
                    },
                    {
                        range: { first: 82, second: 85 },
                        percentage: 0,
                        count: 0
                    }
                ],
                candidateLegendValue: 55,
                positionOnChart: 55
            }
        },
        userSkillAcquisitionDetailInfo: {
            skillAcquisitionRate: 89.1,
            skillAcquisitionRateRank: 1,
            totalSkillAcquisitionRateRank: 2,
            comparedToOverallAverageRateInAssessment: 19.0,
            statPosition: "HIGHEST",
            candidateLegendValue: 89,
            positionOnChart: 89,
            distribution: [
                {
                    range: { first: 0, second: 9 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 10, second: 19 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 20, second: 29 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 30, second: 39 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 40, second: 49 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 50, second: 59 },
                    percentage: 50,
                    count: 1
                },
                {
                    range: { first: 60, second: 69 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 70, second: 79 },
                    percentage: 0,
                    count: 0
                },
                {
                    range: { first: 80, second: 89 },
                    percentage: 50,
                    count: 1
                },
                {
                    range: { first: 90, second: 100 },
                    percentage: 0,
                    count: 0
                }
            ]
        }
    }
];

export const reportSampleSkillCandidateSummaries = [
    {
        trackSummary: {
            trackName: "Prompt Engineering for Developers",
            trackLevelName: "Beginner",
            trackId: 572,
            trackLevelId: 874,
            testTemplateId: 0
        },
        skills: [
            {
                id: 703,
                name: "Prompt Engineering Fundamentals",
                description: "Able to craft clear prompts and control the model's basic behavior.",
                distribution: {
                    acquired: {
                        percentage: 100.0,
                        count: 2
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The candidate excels at instructing AI with clear role definitions—like 'You are a security-focused senior reviewer'—and breaks down tasks into specific dimensions: code quality, security, and performance. They design detailed output templates requiring description, severity level, rationale, and fix suggestions for each issue, and set clear priorities (security first, then performance, then style). They also specify tone (professional, constructive) and adapt language to context. This shows strong command of fundamental AI instruction techniques.",
                    weaknesses: ""
                }
            },
            {
                id: 704,
                name: "Constraint-based Output Control",
                description: "Able to include explicit constraints in prompts to obtain the desired outputs.",
                distribution: {
                    acquired: {
                        percentage: 100.0,
                        count: 2
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The candidate shows strong ability to constrain AI outputs by requiring a single, consistent format (like structured Markdown) and specifying fixed sections in strict order: name, parameters, returns, errors, side effects, examples. They adjust instructions based on artifact type (function vs. class, synchronous vs. asynchronous), and mandate formal, technical vocabulary. This demonstrates excellent structural control over documentation outputs.",
                    weaknesses: ""
                }
            },
            {
                id: 705,
                name: "Structured Data Input/Output JSON",
                description: "Able to control input/output in predefined data formats to facilitate downstream processing",
                distribution: {
                    acquired: {
                        percentage: 100.0,
                        count: 2
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The candidate designs a clear JSON structure with function_name, test_suite_description, and test_cases array, requiring each test case to contain test_name, description, input_parameters, expected_output, and test_category. They emphasize that JSON must be valid and parsable by testing frameworks and CI pipelines, ensuring real-world usability. They also require coverage of normal, edge, and error cases, and support nested objects and arrays for complex data. This shows near-complete mastery of JSON-based structured output design for practical automation.",
                    weaknesses: ""
                }
            },
            {
                id: 706,
                name: "Structured Data Input/Output XML",
                description: "Able to control input/output in predefined data formats to facilitate downstream processing",
                distribution: {
                    acquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    needsImprovement: {
                        percentage: 50.0,
                        count: 1
                    },
                    notAcquired: {
                        percentage: 50.0,
                        count: 1
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "NEEDS_IMPROVEMENT",
                    strength: "",
                    weaknesses: "The candidate defines mandatory report sections (Summary, Key Metrics, Incidents, Action Items, Risks) as XML elements but does not consistently apply attributes to mark required sections. They miss a dedicated highlight element to emphasize trends and business impact (not just list data), and the style element lacks clear encoding of tone and format. The XML structure also lacks a concrete formatting example, giving downstream systems less guidance on expected output shape. To improve, they should add consistent attribute schemes, highlight and style details, and embed realistic examples in the XML template."
                }
            }
        ]
    },
    {
        trackSummary: {
            trackName: "JavaScript",
            trackLevelName: "Intermediate",
            trackId: 200001,
            trackLevelId: 82,
            testTemplateId: 1
        },
        skills: [
            {
                id: 467,
                name: "Function Design and Implementation",
                description: "This skill verifies the ability to define and call functions, and to appropriately separate and implement program logic. Candidates should be able to use parameters and return values correctly, while enhancing reusability and readability of functions.",
                distribution: {
                    acquired: {
                        percentage: 50.0,
                        count: 1
                    },
                    needsImprovement: {
                        percentage: 50.0,
                        count: 1
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The learner correctly implements create, findDevice, turnOn, turnOff, getDeviceInfo and setTemperature with the required parameters and behaviors, showing solid function implementation skills. create initializes and registers a device while returning an appropriate message, and turnOn and turnOff change status based on current state. findDevice locates a device by id, getDeviceInfo returns structured information, and setTemperature updates temperature for the specified device. Each method has a clear responsibility and matches the instructed behavior, indicating an intermediate level of function design and implementation.",
                    weaknesses: ""
                }
            },
            {
                id: 468,
                name: "Object-Oriented Programming",
                description: "This skill verifies the ability to structure programs and design reusable modules using classes and objects. Candidates should understand concepts such as inheritance, encapsulation, and polymorphism, and be able to apply them in code.",
                distribution: {
                    acquired: {
                        percentage: 100.0,
                        count: 2
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The learner clearly understands inheritance by implementing SmartAirConditioner as a subclass of SmartDevice and placing shared behavior in the base class. SmartDevice exposes required public properties such as deviceId and status while deviceName is implemented as a private field, satisfying the encapsulation requirement. SmartAirConditioner adds its own temperature and mode properties, cleanly separating common and specialized behavior. This shows they can translate the given class and property requirements into working code and apply object oriented design at an intermediate level.",
                    weaknesses: ""
                }
            },
            {
                id: 469,
                name: "Data Structure Utilization",
                description: "This skill verifies the ability to select and utilize various data structures—such as arrays, objects, Maps, and Sets—according to their purpose. Candidates should be able to efficiently perform operations such as insertion, deletion, search, and sorting using appropriate data structures.",
                distribution: {
                    acquired: {
                        percentage: 50.0,
                        count: 1
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 50.0,
                        count: 1
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The learner models device states and modes with enumeration like objects and uses SmartDevice.registry as a keyed collection to look up devices by id, aligning data structures with the required access patterns. findDevice searches this registry to return the matching instance, and getDeviceInfo builds a structured result from stored properties. In create, devices are registered into the central collection so later lookups are efficient. These choices show they can connect the instructions about registry based search and JSON style info to concrete data structure usage and design.",
                    weaknesses: ""
                }
            },
            {
                id: 470,
                name: "Error & Exception Handling",
                description: "This skill is designed to verify the ability to handle errors and exceptions in a JavaScript environment to ensure program stability. Candidates should be able to manage runtime errors using constructs such as try–catch and error objects, handle exceptions in asynchronous operations, and proactively prevent predictable error scenarios.",
                distribution: {
                    acquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    needsImprovement: {
                        percentage: 100.0,
                        count: 2
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "NEEDS_IMPROVEMENT",
                    strength: "",
                    weaknesses: "The learner distinguishes some conditions with different messages, but the handling of all required situations is not fully systematic. In create and the power control methods certain status combinations lead to appropriate messages, yet findDevice, getDeviceInfo and setTemperature do not implement every condition specific message described in the instructions. As a result, some error like cases are not clearly separated from normal ones. To improve this competency they should enumerate all condition combinations for each method and map each case to the exact message defined, treating these branches as part of a consistent error handling design."
                }
            },
            {
                id: 471,
                name: "State Management",
                description: "This skill verifies the ability to implement conditional logic and control outputs based on application state. Candidates should understand how to evaluate conditions, apply branching structures, and produce the required outputs consistently according to specifications.",
                distribution: {
                    acquired: {
                        percentage: 100.0,
                        count: 2
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The learner manages device state consistently across the required methods. turnOn and turnOff inspect the current status and only change it to ON or OFF when appropriate, distinguishing between valid transitions and already ON or OFF situations. In connectTo they check the status of both devices and return different messages depending on whether connection is allowed. otaUpdate inspects status, blocks updates when the device is OFF, and moves through an updating phase before returning to ON. This shows a clear state driven approach where outputs and transitions follow the instructed rules.",
                    weaknesses: ""
                }
            },
            {
                id: 472,
                name: "Asynchronous Programming",
                description: "This skill verifies the ability to handle asynchronous tasks efficiently and maintain application responsiveness. Candidates should be able to control asynchronous flows using Promises, async/await, and callback functions.",
                distribution: {
                    acquired: {
                        percentage: 100.0,
                        count: 2
                    },
                    needsImprovement: {
                        percentage: 0.0,
                        count: 0
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "ACQUIRED",
                    strength: "The learner fully meets the asynchronous requirements by implementing connectTo and otaUpdate as static async methods that return Promises. connectTo performs lookups and resolves with different messages depending on device status, allowing callers to await the result. otaUpdate uses a timer to simulate the update duration, changing status during the delay and resolving with the completion message afterward. This design shows they can combine Promise based control flow, async functions and timers to implement the specified asynchronous behavior in a clear and reliable way.",
                    weaknesses: ""
                }
            },
            {
                id: 473,
                name: "Output Control and Formatting",
                description: "This skill is designed to verify the ability to present program results in JavaScript in a clear and readable format according to given requirements. Candidates should be able to apply appropriate string handling and output methods to produce well-structured and understandable results.",
                distribution: {
                    acquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    needsImprovement: {
                        percentage: 100.0,
                        count: 2
                    },
                    notAcquired: {
                        percentage: 0.0,
                        count: 0
                    },
                    totalCount: 2
                },
                candidateInfo: {
                    skillLevel: "NEEDS_IMPROVEMENT",
                    strength: "",
                    weaknesses: "The learner returns meaningful messages from several methods, but the formatting and coverage do not fully match the required phrases. In setTemperature the temperature change message is close to the specification yet small details such as spaces around the colon differ from the instructed format. In create, turnOn and turnOff some condition based messages are implemented, while findDevice and getDeviceInfo focus on returning values rather than all specified messages for each condition. To strengthen this competency they should treat the exact message text as part of correctness and ensure every branch uses the precise strings defined in the instructions."
                }
            }
        ]
    }
];

export const reportSampleCandidateActionAnalysis = {
    actionAnalysisInformation: {
        currentGrade: "CLEAN",
        reason: ""
    },
    actionDetails: {
        actions: [
            {
                actionId: 177879,
                action: "TAB_SWITCH",
                actionDateAt: "2026-01-31 01:39:01.957192",
                suspiciousFlag: false
            },
            {
                actionId: 177880,
                action: "PASTE",
                actionDateAt: "2026-01-31 01:47:07.183306",
                suspiciousFlag: false
            },
            {
                actionId: 177881,
                action: "TAB_SWITCH",
                actionDateAt: "2026-01-31 01:47:25.938406",
                suspiciousFlag: false
            },
            {
                actionId: 177882,
                action: "PASTE",
                actionDateAt: "2026-01-31 01:54:24.950937",
                suspiciousFlag: false
            },
            {
                actionId: 177883,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:00:04.089326",
                suspiciousFlag: false
            },
            {
                actionId: 177884,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:03:20.939456",
                suspiciousFlag: false
            },
            {
                actionId: 177885,
                action: "COPY",
                actionDateAt: "2026-01-31 02:12:55.155340",
                suspiciousFlag: false
            },
            {
                actionId: 177886,
                action: "COPY",
                actionDateAt: "2026-01-31 02:12:58.543380",
                suspiciousFlag: false
            },
            {
                actionId: 177887,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:12:59.348350",
                suspiciousFlag: false
            },
            {
                actionId: 177888,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:13:48.408425",
                suspiciousFlag: false
            },
            {
                actionId: 177889,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:14:44.795756",
                suspiciousFlag: false
            },
            {
                actionId: 177890,
                action: "COPY",
                actionDateAt: "2026-01-31 02:21:30.407635",
                suspiciousFlag: false
            },
            {
                actionId: 177891,
                action: "COPY",
                actionDateAt: "2026-01-31 02:21:30.601954",
                suspiciousFlag: false
            },
            {
                actionId: 177892,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:21:32.761410",
                suspiciousFlag: false
            },
            {
                actionId: 177893,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:22:53.838067",
                suspiciousFlag: false
            },
            {
                actionId: 177894,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:24:03.121356",
                suspiciousFlag: false
            },
            {
                actionId: 177895,
                action: "CUT",
                actionDateAt: "2026-01-31 02:25:09.194290",
                suspiciousFlag: false
            },
            {
                actionId: 177896,
                action: "COPY",
                actionDateAt: "2026-01-31 02:25:09.196215",
                suspiciousFlag: false
            },
            {
                actionId: 177897,
                action: "COPY",
                actionDateAt: "2026-01-31 02:25:10.052662",
                suspiciousFlag: false
            },
            {
                actionId: 177898,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:25:14.141361",
                suspiciousFlag: false
            },
            {
                actionId: 177899,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:26:49.261393",
                suspiciousFlag: false
            },
            {
                actionId: 177905,
                action: "COPY",
                actionDateAt: "2026-01-31 02:39:24.625890",
                actionContent: "SmartDevice",
                suspiciousFlag: false
            },
            {
                actionId: 177906,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:39:25.514335",
                actionContent: "SmartDevice",
                suspiciousFlag: false
            },
            {
                actionId: 177907,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:39:30.431098",
                actionContent: "SmartDevice",
                suspiciousFlag: false
            },
            {
                actionId: 177908,
                action: "COPY",
                actionDateAt: "2026-01-31 02:42:24.879488",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177909,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:42:27.234960",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177910,
                action: "COPY",
                actionDateAt: "2026-01-31 02:43:32.513720",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177911,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:43:33.739543",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177912,
                action: "CUT",
                actionDateAt: "2026-01-31 02:44:20.494460",
                actionContent: "if (prevStatus === SMART_DEVICE_STATUS.ON) {\n      return \"Already\"\n    }",
                suspiciousFlag: false
            },
            {
                actionId: 177913,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:44:22.870623",
                actionContent: "if (prevStatus === SMART_DEVICE_STATUS.ON) {\n      return \"Already\"\n    }",
                suspiciousFlag: false
            },
            {
                actionId: 177916,
                action: "CUT",
                actionDateAt: "2026-01-31 02:53:55.196807",
                actionContent: "\"Device not found\"",
                suspiciousFlag: false
            },
            {
                actionId: 177917,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:53:56.974493",
                actionContent: "\"Device not found\"",
                suspiciousFlag: false
            },
            {
                actionId: 177918,
                action: "CUT",
                actionDateAt: "2026-01-31 02:54:01.073674",
                actionContent: "\"Device offline\"",
                suspiciousFlag: false
            },
            {
                actionId: 177919,
                action: "PASTE",
                actionDateAt: "2026-01-31 02:54:03.656734",
                actionContent: "\"Device offline\"",
                suspiciousFlag: false
            },
            {
                actionId: 177922,
                action: "CUT",
                actionDateAt: "2026-01-31 02:55:40.333145",
                actionContent: "const device = SmartDevice.registry[id];\n    if (!device) {\n      \n    }",
                suspiciousFlag: false
            },
            {
                actionId: 177930,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:05:45.494728",
                actionContent: "const device = SmartDevice.registry[id];\n    if (!device) {\n      \n    }",
                suspiciousFlag: false
            },
            {
                actionId: 177931,
                action: "COPY",
                actionDateAt: "2026-01-31 03:09:25.161449",
                actionContent: "device",
                suspiciousFlag: false
            },
            {
                actionId: 177932,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:09:27.796687",
                actionContent: "device",
                suspiciousFlag: false
            },
            {
                actionId: 177933,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:09:35.323962",
                actionContent: "device",
                suspiciousFlag: false
            },
            {
                actionId: 177934,
                action: "COPY",
                actionDateAt: "2026-01-31 03:10:26.880773",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177935,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:10:31.514545",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177938,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:11:22.381331",
                actionContent: "Temperature : 23°C",
                suspiciousFlag: false
            },
            {
                actionId: 177939,
                action: "COPY",
                actionDateAt: "2026-01-31 03:11:24.832357",
                actionContent: "°C",
                suspiciousFlag: false
            },
            {
                actionId: 177940,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:11:25.826372",
                actionContent: "°C",
                suspiciousFlag: false
            },
            {
                actionId: 177946,
                action: "COPY",
                actionDateAt: "2026-01-31 03:13:57.624435",
                actionContent: "AC_MODE",
                suspiciousFlag: false
            },
            {
                actionId: 177947,
                action: "COPY",
                actionDateAt: "2026-01-31 03:16:20.525324",
                actionContent: "",
                suspiciousFlag: false
            },
            {
                actionId: 177948,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:16:21.817554",
                actionContent: "SmartAirConditioner",
                suspiciousFlag: false
            },
            {
                actionId: 177949,
                action: "COPY",
                actionDateAt: "2026-01-31 03:16:48.617063",
                actionContent: "resolve",
                suspiciousFlag: false
            },
            {
                actionId: 177950,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:16:49.283437",
                actionContent: "resolve",
                suspiciousFlag: false
            },
            {
                actionId: 177951,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:16:50.324892",
                actionContent: "resolve",
                suspiciousFlag: false
            },
            {
                actionId: 177952,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:16:54.015597",
                actionContent: "resolve",
                suspiciousFlag: false
            },
            {
                actionId: 177953,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:16:55.578158",
                actionContent: "resolve",
                suspiciousFlag: false
            },
            {
                actionId: 177955,
                action: "COPY",
                actionDateAt: "2026-01-31 03:20:23.668455",
                actionContent: "deviceId",
                suspiciousFlag: false
            },
            {
                actionId: 177956,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:20:29.728727",
                actionContent: "deviceId",
                suspiciousFlag: false
            },
            {
                actionId: 177958,
                action: "COPY",
                actionDateAt: "2026-01-31 03:20:58.223432",
                actionContent: "clone",
                suspiciousFlag: false
            },
            {
                actionId: 177959,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:21:00.620791",
                actionContent: "clone",
                suspiciousFlag: false
            },
            {
                actionId: 177960,
                action: "COPY",
                actionDateAt: "2026-01-31 03:22:39.681375",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            },
            {
                actionId: 177961,
                action: "PASTE",
                actionDateAt: "2026-01-31 03:22:40.929271",
                actionContent: "SMART_DEVICE_STATUS",
                suspiciousFlag: false
            }
        ]
    }
};